module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("本店(" + _vm._s(_vm.schoolName) + ")目前支持的配送楼栋如下：")]), _vm._v(" "), (_vm.buildsList.length > 0) ? _c('div', {
    staticClass: "builds"
  }, _vm._l((_vm.buildsList), function(item) {
    return _c('div', {
      staticClass: "builds"
    }, [_vm._v(_vm._s(item.area)), (item.msg) ? _c('span', [_vm._v(_vm._s(item.msg))]) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "ac"
  }, [_vm._v("暂无楼栋")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-67ae5772","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/FindBuild.vue
// module id = 446
// module chunks = 7